import { useContext } from 'react'
import LanguageContext from 'state/contexts/LanguageContext'

const useLanguage = () => useContext(LanguageContext)

export default useLanguage
